import React from "react";
import { WAREHOUSES } from "@/lib/api";
import { useLang } from "@/contexts/LanguageContext";
import { Label } from "@/components/ui/label";
import { selectCls } from "@/components/stock/LineItemsEditor";

export const FormField = ({ label, children, className = "" }) => (
  <div className={className}>
    <Label className="text-xs uppercase tracking-wider text-slate-500">{label}</Label>
    <div className="mt-1">{children}</div>
  </div>
);

export const WarehouseSelect = ({ value, onChange, availableOnly = false, allLabel, testid }) => {
  const { t } = useLang();
  return (
    <select className={selectCls} value={value} onChange={(e) => onChange(e.target.value)} data-testid={testid}>
      {allLabel && <option value="">{allLabel}</option>}
      {WAREHOUSES.filter((w) => !availableOnly || w.available).map((w) => (
        <option key={w.v} value={w.v}>{t(w.labelKey)}</option>
      ))}
    </select>
  );
};

export const SegToggle = ({ value, options, onChange, testid }) => (
  <div className="inline-flex w-fit rounded-md border border-slate-300 overflow-hidden" data-testid={testid}>
    {options.map((o) => (
      <button key={o.v} type="button" onClick={() => onChange(o.v)} data-testid={`${testid}-${o.v}`}
              className={`px-4 py-1.5 text-sm font-medium transition-colors ${value === o.v ? "bg-slate-900 text-white" : "bg-white text-slate-600 hover:bg-slate-100"}`}>
        {o.label}
      </button>
    ))}
  </div>
);
